// extracted by mini-css-extract-plugin
module.exports = {"menu-items":"FileUpload_menu-items__mlXkh","active":"FileUpload_active__1rHKE"};